import HARDCODE from '../../../business-const/HardCode/HardCode'

import MESSAGE from '../../../business-const/Message/Message'

import {
    dataAtual,
    ano,
    mes,
    dia,
    dataAnoMesDia,
    converteDataExtensoData,
    stringParaData,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import {
    sortAsc
} from '../../../business-components/Sort/Sort'

import {
    semZerosEsquerda
} from '../../../business-components/String/String'

import {
    trataTexto,
    trataValorTexto,
    trataInteiro,
    trataData,
} from '../cliente-form/ClienteServiceImportacao'

import {
    espaco,
    fimLinha,
    identificaTipoCoberturaSeguroVida,
    identificaStatusCobertura,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    obtemDadoPDFAvulso,
    obtemDadoXLSX,
    timeSeguradora,
    idAgenteTimeSeguradora,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiCoberturas,
    numeroCotacaoAutomatico,
    incluiTabelaEvolucaoValorResgateCoberturaVidaInteira,
} from './IntegracaoClienteArquivoService'



export const importaPropostaPrudential = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {


    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)


    PDFTxt = PDFTxt.replace(fimLinha + 'PROPOSTA DE CONTRATAÇÃO DE SEGURO Nº' + espaco, 
        fimLinha + 'PROPOSTA DE CONTRATAÇÃO DE SEGURO DE VIDA Nº' + espaco)


    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'PROPOSTA DE CONTRATAÇÃO DE SEGURO DE VIDA Nº' + espaco, fimLinha,
        HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].statusProposta = HARDCODE.idStatusPropostaPendente

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nome do Segurado:' + espaco, 'Idade:',
        HARDCODE.importacaoNomeSeguradoCliente, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].nomeSeguradoCliente) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nome ou Nome Social do Segurado:' + espaco, 'Idade:',
            HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data de Nascimento:' + espaco, espaco, 
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, 'Sexo:' + espaco, espaco,
        HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, 'CPF:' + espaco, espaco, 
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)
    
    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Telefone Celular:' + espaco, espaco + 'Telefone Comercial:',
        HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Endereço de Correspondência do Segurado' + fimLinha + 'Logradouro:' + espaco,
        fimLinha, HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Número:' + fimLinha,
    //    fimLinha, HARDCODE.importacaoNumeroEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nº e Complemento:' + espaco,
        'Bairro:', HARDCODE.importacaoComplementoEnderecoSeguradoCliente, false, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, 'Bairro:' + espaco, fimLinha,
        HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Cidade:' + espaco, espaco + 'Estado:',
        HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, 'Estado:' + espaco, espaco,
        HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, 'CEP:' + espaco, espaco + 'Possui',
        HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

    if (PDFTxt.substring(jsonRegistros.indexInicial, jsonRegistros.indexInicial + 100).indexOf('Atividade profissional:' + espaco) !== -1) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Atividade profissional:' + espaco, fimLinha,
            HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Faturamento Anual ou Renda Anual:' + espaco, espaco + 'Possui',
            HARDCODE.importacaoRendaMensal, true, null, erros, nomeArquivo)

        jsonRegistros.jsonRegistros[indexJsonRegistros].rendaMensal = round(jsonRegistros.jsonRegistros[indexJsonRegistros].rendaMensal / 12, 2)
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'E-mail:' + espaco, fimLinha,
        HARDCODE.importacaoEmailSeguradoCliente, false, null, erros, nomeArquivo)
    
    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].emailSeguradoCliente) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'E-mail:' + espaco, fimLinha,
            HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Automática Valor do Prêmio Valor IOF' + fimLinha,
        fimLinha + 'C. Informações sobre o Pagamento dos Prêmios' + espaco + fimLinha,
            HARDCODE.importacaoPropostaCoberturas, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Periodicidade de Pagamento:' + espaco, espaco,
        HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data de Finalização' + espaco, espaco,
        HARDCODE.importacaoDataAssinatura, false, null, erros, nomeArquivo)


    if (jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas) {

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replace(
                fimLinha + 'COBERTURAS OPCIONAIS DE SEGURO DE' + espaco + fimLinha + 'VIDA' + fimLinha + 'CLASSE DE' + espaco +
                fimLinha + 'AJUSTE' + fimLinha + 'CAPITAL SEGURADO' + espaco + fimLinha + 'INICIAL/VALOR DA DIÁRIA (HC)' +
                    fimLinha + 'EXTENSÃO' + espaco + fimLinha + 'AUTOMÁTICA VALOR DO PRÊMIO VALOR IOF', '')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('NÃO SE APLICA' + espaco, '')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('NÃO' + espaco + fimLinha +
                'FUMANTE-' + fimLinha, 'NÃO-FUMANTE-')
          
        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('CLASSE A', 'CLASSE-A')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('CLASSE B', 'CLASSE-B')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('CLASSE C', 'CLASSE-C')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('CLASSE D', 'CLASSE-D')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('CLASSE E', 'CLASSE-E')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('CLASSE F', 'CLASSE-F')
              
        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('SIM' + espaco, '')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('NÃO' + espaco, '')

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas =
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.replaceAll('R$', '')


        const linhasCoberturaAux = jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.split(fimLinha)
        let indexLinhasCoberturaAux = 0

        const linhasCobertura = ['']
        let indexLinhasCobertura = 0

        while (indexLinhasCoberturaAux < linhasCoberturaAux.length) {

            linhasCobertura[indexLinhasCobertura] +=
                (linhasCobertura[indexLinhasCobertura] ? espaco : '' ) + linhasCoberturaAux[indexLinhasCoberturaAux]

            if (
                    linhasCoberturaAux[indexLinhasCoberturaAux].indexOf(',') !== -1 &&
                    indexLinhasCoberturaAux + 1 < linhasCoberturaAux.length
            ) {

                indexLinhasCobertura++

                linhasCobertura.push('')
            }

            indexLinhasCoberturaAux++
        }


        const coberturas = []

        let numeroCobertura
        let codigoCobertura
        let descricaoCobertura
        let dadosCobertura
        let valorCS
        let valorPremioLiquido
        let valorIof
        let valorPremio
        let classeAjusteRisco = ''
        let valorPremioExtra = ''
        let duracaoPremioExtra = ''
        let dataTerminoCobertura
        let valorRendaMensal = ''

        indexLinhasCobertura = 0

        while (indexLinhasCobertura < linhasCobertura.length) {

            dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)
            
            valorCS = trataValorTexto(dadosCobertura[dadosCobertura.length - 5])
            valorPremioLiquido = trataValorTexto(dadosCobertura[dadosCobertura.length - 3])
            valorIof = trataValorTexto(dadosCobertura[dadosCobertura.length - 1])
            valorPremio = valorPremioLiquido + valorIof

            classeAjusteRisco = dadosCobertura[dadosCobertura.length - 7]

            if (classeAjusteRisco) {
            
                const classeAjusteRiscoConversao =
                    pesquisaList(linhaIntegracao.classeAjuste, classeAjusteRisco).idConversao

                if (classeAjusteRiscoConversao) {

                    classeAjusteRisco = classeAjusteRiscoConversao
                }
            }

            descricaoCobertura = ''

            indexLinhasCoberturaAux = 0

            while (indexLinhasCoberturaAux < dadosCobertura.length - 7) {
            
                descricaoCobertura += (descricaoCobertura ? espaco : '') + dadosCobertura[indexLinhasCoberturaAux]
            
                indexLinhasCoberturaAux++
            }

            const tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

            incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida, null, valorCS,
                valorPremioLiquido, valorIof, valorPremio, classeAjusteRisco, valorPremioExtra, duracaoPremioExtra,
                    dataTerminoCobertura, valorRendaMensal)

            indexLinhasCobertura += 1
        }

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas = coberturas
    }



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
    


    return jsonRegistros.jsonRegistros
}



export const importaApolicePrudential = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    let modeloCobertura

    let numeroApoliceAnt = ''

    PDFTxt = PDFTxt.replaceAll('Nº da Apólice:', 'Apólice:')
    PDFTxt = PDFTxt.replaceAll('Nº da Proposta:', 'Proposta:')
    PDFTxt = PDFTxt.replaceAll('Nome do Segurado:', 'Segurado:')
    PDFTxt = PDFTxt.replaceAll('Endereço Residencial:', 'Endereço:')
    PDFTxt = PDFTxt.replaceAll('Telefone Residencial:', 'Telefone:')
    PDFTxt = PDFTxt.replaceAll('Telefone Comercial:', 'Tel.Comercial:')
    PDFTxt = PDFTxt.replaceAll('Telefone Celular:', 'Celular:')
    PDFTxt = PDFTxt.replaceAll('Periodicidade:', 'Periodicidade Pagto.:')
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Profissão Responsável pelo Pagamento:', espaco + 'Profissão Responsável pelo Pagamento:')
   
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Apólice com' + fimLinha + 'Sinistro' + fimLinha, fimLinha + 'Apólice com Sinistro' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Benefício' + fimLinha + 'Pago' + fimLinha, fimLinha + 'Benefício Pago' + espaco)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Fumante-' + fimLinha + 'Standard' + fimLinha, espaco + 'Fumante-Standard' + espaco)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Não Fumante-' + fimLinha + 'Standard' + fimLinha, espaco + 'Não Fumante-Standard' + espaco)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Não Fumante-' + fimLinha + 'Classe A' + fimLinha, espaco + 'Não Fumante-Classe A' + espaco)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Não Fumante-' + fimLinha + 'Classe B' + fimLinha, espaco + 'Não Fumante-Classe B' + espaco)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Não Fumante-' + fimLinha + 'Classe C' + fimLinha, espaco + 'Não Fumante-Classe C' + espaco)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Não Fumante-' + fimLinha + 'Classe D' + fimLinha, espaco + 'Não Fumante-Classe D' + espaco)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Não Fumante-' + fimLinha + 'Classe E' + fimLinha, espaco + 'Não Fumante-Classe E' + espaco)
    PDFTxt = PDFTxt.replaceAll(espaco + fimLinha, fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Não Fumante-' + fimLinha + 'Classe F' + fimLinha, espaco + 'Não Fumante-Classe F' + espaco)
    PDFTxt = PDFTxt.replaceAll(espaco + 'Premium Paying' + espaco, fimLinha + 'Premium Paying' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + '(Regular)' + espaco, fimLinha + '(Regular)' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'Paid-Up Life' + espaco, fimLinha + 'Paid-Up Life' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Paid-Up Life' + espaco, fimLinha + 'Paid-Up Life' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'anos C' + fimLinha, espaco + 'anos C' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'anos F' + fimLinha, espaco + 'anos F' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'anos' + fimLinha + 'C' + fimLinha, espaco + 'anos C' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'anos' + fimLinha + 'C Surrendered' + espaco,
        espaco + 'anos C' + fimLinha + 'Surrendered' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Plus 5-B**' + fimLinha, espaco + 'Plus 5-B**' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Plus 5-C**' + fimLinha, espaco + 'Plus 5-C**' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Plus 5-B** Surrendered' + espaco, espaco + 'Plus 5-B**' + fimLinha + 'Surrendered' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Opção Plus 5-C**' + fimLinha, espaco + 'Opção Plus 5-C**' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'anos*' + fimLinha, espaco + 'anos*' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'DR15 Temporário Decrescente' + fimLinha + 'por 15 anos Converted' + espaco,
        fimLinha + 'DR15 Temporário Decrescente' + espaco + 'por 15 anos' + fimLinha + 'Converted' + fimLinha)
    //PDFTxt = PDFTxt.replaceAll(espaco + 'Temporário' + fimLinha + 'Decrescente por' + espaco,
    //    espaco + 'Temporário Decrescente por' + espaco)
    //PDFTxt = PDFTxt.replaceAll(espaco + 'Doenças Graves' + fimLinha + 'Opção Plus' + espaco,
    //    espaco + 'Doenças Graves Opção Plus' + espaco)
    //PDFTxt = PDFTxt.replaceAll(espaco + 'Renda Hospitalar' + fimLinha + 'por' + espaco,
    //    espaco + 'Renda Hospitalar por' + espaco)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'ADP60 Morte Acid.até 75 pago' + fimLinha + 'até 60 anos* Paid-Up Annuit' + espaco,
        fimLinha + 'ADP60 Morte Acid.até 75 pago' + espaco + 'até 60 anos*' + fimLinha + 'Paid-Up Annuit' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'anos* Paid-Up Annuit' + espaco, espaco + 'anos*' + fimLinha + 'Paid-Up Annuit' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'anos* Lapsed' + espaco, espaco + 'anos*' + fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'anos* Lapsed' + espaco, espaco + 'anos*' + fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'anos** Lapsed' + espaco, espaco + 'anos**' + fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'anos*** Lapsed' + espaco, espaco + 'anos***' + fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'por 5 anos C Lapsed' + espaco, espaco + 'por 5 anos C' + fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'por 10 anos C Lapsed' + espaco, espaco + 'por 10 anos C' + fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'por 20 anos Lapsed' + espaco, espaco + 'por 20 anos' + fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Básica 5-B** Lapsed' + espaco, espaco + 'Básica 5-B**' + fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Lapsed' + espaco, fimLinha + 'Lapsed' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'pago' + fimLinha + 'até' + espaco, espaco + 'pago até' + espaco)
    PDFTxt = PDFTxt.replaceAll(espaco + 'por 10' + fimLinha + 'anos***', espaco + 'por 10 anos***')
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'por 5 anos C' + fimLinha, espaco + 'por 5 anos C' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Saldado (A_)' + fimLinha, espaco + 'Saldado (A_)' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Saldado (B_)' + fimLinha, espaco + 'Saldado (B_)' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'Expired' + espaco, fimLinha + 'Expired' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'Surrendered' + espaco, fimLinha + 'Surrendered' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Surrendered' + espaco, fimLinha + 'Surrendered' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Expired' + espaco, fimLinha + 'Expired' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(espaco + 'Converted' + espaco, fimLinha + 'Converted' + fimLinha)
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Converted' + espaco, fimLinha + 'Converted' + fimLinha)
    //console.log(PDFTxt)
     
    while (PDFTxt.indexOf('Segurado:', jsonRegistros.indexInicial) > 0) {

        jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

        const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Apólice:' + espaco, espaco, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
      
        while (jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice === numeroApoliceAnt) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Apólice:' + espaco, espaco,
                HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
        }

        numeroApoliceAnt = jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice

        jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
            semZerosEsquerda(jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco, espaco + 'Proposta:', 
            HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Proposta:' + espaco, fimLinha, 
            HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
        
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data da Emissão:' + espaco, espaco, 
            HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Segurado:' + espaco, espaco + 'CPF:',
            HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)
        
        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'CPF:' + espaco, fimLinha,
            HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

        if (PDFTxt.substring(jsonRegistros.indexInicial, jsonRegistros.indexInicial + 100).indexOf('Profissão:' + espaco) !== -1) {

            obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Profissão:' + espaco, fimLinha, 
                HARDCODE.importacaoProfissaoSegurado, false, null, erros, nomeArquivo)
        }
        
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data de Nascimento:' + espaco, espaco,
            HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)
        
        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Sexo:' + espaco, fimLinha,
            HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Endereço:' + espaco, espaco + 'Bairro:',
            HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Bairro:'/* + espaco*/, fimLinha,
            HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)
            
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Cidade:' + espaco, espaco + 'Estado:',
            HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Estado:' + espaco, espaco,
            HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'CEP:' + espaco, fimLinha,
            HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone:', espaco + 'Tel.Comercial:',
            HARDCODE.importacaoTelefoneSegurado, false, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Tel.Comercial:', fimLinha,
            HARDCODE.importacaoTelefoneComercialSegurado, false, null, erros, nomeArquivo)
        
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Celular:', espaco + 'E-mail:',
            HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'E-mail:'/* + espaco*/, fimLinha,
            HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Responsável pelo Pagamento:' + espaco, /*espaco + */'CPF / CNPJ:',
            HARDCODE.importacaoNomeRespPagto, false, null, erros, nomeArquivo)
        //console.log(jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)

        if (jsonRegistros.jsonRegistros[indexJsonRegistros].nomeRespPagto) {

            obtemDadoPDF(PDFTxt, jsonRegistros, /*espaco + */'CPF / CNPJ:' + espaco, fimLinha,
                HARDCODE.importacaoCpfCnpjRespPagto, true, null, erros, nomeArquivo)
            
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto.length === 14) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto = ''

            } else {

                obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo do Responsável pelo Pagamento:' + espaco,
                    /*espaco + */'Profissão Responsável pelo Pagamento:', HARDCODE.importacaoSexoRespPagto, false, null, erros, nomeArquivo)
                }

        } else {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Responsável pelo Pagamento:' + espaco, fimLinha,
                HARDCODE.importacaoNomeRespPagto, true, null, erros, nomeArquivo)
            
            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CPF / CNPJ:' + espaco, fimLinha,
                HARDCODE.importacaoCpfCnpjRespPagto, true, null, erros, nomeArquivo)
                
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto.length === 14) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto = ''

            } else {

                obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo do Responsável pelo Pagamento:' + espaco,
                fimLinha, HARDCODE.importacaoSexoRespPagto, false, null, erros, nomeArquivo)
            }
        }
        

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Extensão de' + fimLinha + 'Vigência' + fimLinha,
            fimLinha + 'Prêmio Líquido Total:' + espaco, HARDCODE.importacaoCoberturas, false, null, erros, nomeArquivo)

        modeloCobertura = 1

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Duração Prêmio' + fimLinha + 'Extra' + fimLinha,
                fimLinha + '1) Valor já incluso no prêmio líquido por cobertura.' + fimLinha,
                    HARDCODE.importacaoCoberturas, false, null, erros, nomeArquivo)

            if (!jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas) {

                obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Duração' + fimLinha + 'Prêmio Extra' + fimLinha,
                    fimLinha + 'Prêmio Líquido Total:' + espaco,
                        HARDCODE.importacaoCoberturas, true, null, erros, nomeArquivo)
            }

            modeloCobertura = 2
        }



        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Periodicidade Pagto.:' + espaco, 1/*espaco*/,
            HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)



        if (
                jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas &&
                jsonRegistros.jsonRegistros[indexJsonRegistros].statusApolice.length === 1
        ) {

            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
                jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.replace(fimLinha + 'SUPER' + fimLinha + 'PREFERENCIAL' + fimLinha,
                    espaco + 'SUPER PREFERENCIAL' + espaco)

            const linhasCobertura = jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.split(fimLinha)

            let indexLinhasCobertura = 0


            const coberturas = []

            let indexPesquisa
            let linhaConversaoIntegracao

            let linhaEspecial
            let indexPesquisaLinhaEspecial
            let posStatusCoberturaLinhaEspecial

            let numeroCobertura
            let codigoCobertura
            let descricaoCobertura
            let dadosCobertura
            let posDadosCobertura
            let valorCS
            let valorPremioLiquido
            let valorIof
            let valorPremio
            let indexCobertura
            let classeAjusteRisco
            let valorPremioExtra
            let duracaoPremioExtra
            let dataTerminoCobertura
            let valorRendaMensal

            //console.log(linhasCobertura)
            while (indexLinhasCobertura < linhasCobertura.length) {

                descricaoCobertura = linhasCobertura[indexLinhasCobertura]

                if (descricaoCobertura.length > 50) {

                    indexPesquisa = 0

                    linhaEspecial = linhasCobertura[indexLinhasCobertura].split(espaco)

                    linhaConversaoIntegracao = {}

                    indexPesquisaLinhaEspecial = 0

                    while (!linhaConversaoIntegracao.id) {

                        linhaConversaoIntegracao = pesquisaList(linhaIntegracao.statusCobertura, linhaEspecial[indexPesquisaLinhaEspecial])

                        if (!linhaConversaoIntegracao.id) {

                            linhaConversaoIntegracao = pesquisaList(linhaIntegracao.statusCobertura,
                                linhaEspecial[indexPesquisaLinhaEspecial] + espaco + linhaEspecial[indexPesquisaLinhaEspecial + 1])
                        }

                        indexPesquisaLinhaEspecial++
                    }

                    posStatusCoberturaLinhaEspecial = linhasCobertura[indexLinhasCobertura].indexOf(linhaConversaoIntegracao.id)

                    descricaoCobertura = linhasCobertura[indexLinhasCobertura].substring(0, posStatusCoberturaLinhaEspecial - 1)

                    dadosCobertura = linhasCobertura[indexLinhasCobertura].substring(posStatusCoberturaLinhaEspecial +
                        linhaConversaoIntegracao.id.length + 1)

                } else {

                    indexPesquisa = 1

                    linhaConversaoIntegracao = pesquisaList(linhaIntegracao.statusCobertura, linhasCobertura[indexLinhasCobertura + indexPesquisa])

                    if (!linhaConversaoIntegracao.id) {

                        descricaoCobertura += ' ' + linhasCobertura[indexLinhasCobertura + 1]

                        indexPesquisa++

                        linhaConversaoIntegracao =
                            pesquisaList(linhaIntegracao.statusCobertura, linhasCobertura[indexLinhasCobertura + indexPesquisa])
                    }

                    if (!linhaConversaoIntegracao.id) {

                        posDadosCobertura = linhasCobertura[indexLinhasCobertura + indexPesquisa].indexOf(espaco)

                        linhaConversaoIntegracao = pesquisaList(linhaIntegracao.statusCobertura,
                            linhasCobertura[indexLinhasCobertura + indexPesquisa].substring(0, posDadosCobertura))
                        
                        dadosCobertura = linhasCobertura[indexLinhasCobertura + indexPesquisa].substring(posDadosCobertura + 1).split(espaco)

                        if (!linhaConversaoIntegracao.id) {

                            posDadosCobertura = linhasCobertura[indexLinhasCobertura + indexPesquisa].indexOf(espaco, posDadosCobertura + 1)

                            linhaConversaoIntegracao = pesquisaList(linhaIntegracao.statusCobertura,
                                linhasCobertura[indexLinhasCobertura + indexPesquisa].substring(0, posDadosCobertura))

                            dadosCobertura = linhasCobertura[indexLinhasCobertura + indexPesquisa].substring(posDadosCobertura + 1).split(espaco)

                            if (!linhaConversaoIntegracao.id) {

                                descricaoCobertura += ' ' + linhasCobertura[indexLinhasCobertura + indexPesquisa]

                                indexPesquisa++
        
                                linhaConversaoIntegracao =
                                    pesquisaList(linhaIntegracao.statusCobertura, linhasCobertura[indexLinhasCobertura + indexPesquisa])

                                if (!linhaConversaoIntegracao.id) {

                                    if (linhasCobertura[indexLinhasCobertura + indexPesquisa] === "ANNUIT") {

                                        linhaConversaoIntegracao = pesquisaList(linhaIntegracao.statusCobertura,
                                            linhasCobertura[indexLinhasCobertura + indexPesquisa - 1] + ' ' +
                                                linhasCobertura[indexLinhasCobertura + indexPesquisa])
                            
                                        indexPesquisa++

                                        dadosCobertura = linhasCobertura[indexLinhasCobertura + indexPesquisa].split(espaco)

                                    } else {

                                        posDadosCobertura = linhasCobertura[indexLinhasCobertura + indexPesquisa].indexOf(espaco)

                                        linhaConversaoIntegracao = pesquisaList(linhaIntegracao.statusCobertura,
                                            linhasCobertura[indexLinhasCobertura + indexPesquisa].substring(0, posDadosCobertura))
                            
                                        dadosCobertura = linhasCobertura[indexLinhasCobertura + indexPesquisa].substring(posDadosCobertura + 1).split(espaco)
                                    }

                                } else {
                        
                                    indexPesquisa += linhaConversaoIntegracao.linhas

                                    let dadosCoberturaAux = linhasCobertura[indexLinhasCobertura + indexPesquisa]

                                    while (dadosCoberturaAux.indexOf('/') === -1) {

                                        indexPesquisa++

                                        dadosCoberturaAux += ' ' + linhasCobertura[indexLinhasCobertura + indexPesquisa]
                                    }
                                    
                                    dadosCobertura = dadosCoberturaAux.split(espaco)
                                }
                            }
                        }

                    } else {

                        indexPesquisa += linhaConversaoIntegracao.linhas

                        dadosCobertura = linhasCobertura[indexLinhasCobertura + indexPesquisa].split(espaco)
                    }
                }

                if (indexLinhasCobertura + indexPesquisa + 1 < linhasCobertura.length) {

                    if (linhasCobertura[indexLinhasCobertura + indexPesquisa + 1] === 'NÃO') {

                        indexPesquisa++
                    }

                    if (indexLinhasCobertura + indexPesquisa + 1 < linhasCobertura.length) {

                        if (linhasCobertura[indexLinhasCobertura + indexPesquisa + 1] === 'AUTORIZADA') {

                            indexPesquisa++
                        }
                    }
                }

                const tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                    jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

                valorCS = trataValorTexto(dadosCobertura[0])
                valorPremioLiquido = trataValorTexto(dadosCobertura[1])
                valorIof = trataValorTexto(dadosCobertura[3])
                valorPremio = round(valorPremioLiquido + valorIof, 2)

                if (!valorCS && !valorPremioLiquido) {

                    obtemDadoPDFAvulso (jsonRegistros, '', HARDCODE.importacaoValorCS, true, null, erros, nomeArquivo)
                }

                indexCobertura = 4

                classeAjusteRisco = ''
                //console.log(dadosCobertura)

                while (isNaN(dadosCobertura[indexCobertura].substring(0, 1))) {

                    if (classeAjusteRisco) {

                        classeAjusteRisco += espaco
                    }

                    classeAjusteRisco += dadosCobertura[indexCobertura]

                    indexCobertura++
                }

                if (modeloCobertura === 1) {

                    valorPremioExtra = trataValorTexto(dadosCobertura[indexCobertura])
                    duracaoPremioExtra = trataValorTexto(dadosCobertura[indexCobertura + 1])
                    dataTerminoCobertura = trataData(dadosCobertura[indexCobertura + 2])

                } else {

                    valorPremioExtra = trataValorTexto(dadosCobertura[indexCobertura + 1])
                    duracaoPremioExtra = trataValorTexto(dadosCobertura[indexCobertura + 2])
                    dataTerminoCobertura = trataData(dadosCobertura[indexCobertura])
                }

                if (
                        indexLinhasCobertura + indexPesquisa + 1 < linhasCobertura.length &&
                        linhasCobertura[indexLinhasCobertura + indexPesquisa + 1].trim().substring(0, 3) === '***'
                ) {

                    valorRendaMensal = linhasCobertura[indexLinhasCobertura + indexPesquisa + 1]

                    valorRendaMensal = valorRendaMensal.split(espaco)

                    valorRendaMensal = trataValorTexto(valorRendaMensal[valorRendaMensal.length - 1])

                    indexPesquisa++

                } else {

                    valorRendaMensal = null
                }

                incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
                    linhaConversaoIntegracao.idConversao, valorCS, valorPremioLiquido, valorIof, valorPremio, classeAjusteRisco,
                        valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)

                indexLinhasCobertura += indexPesquisa + 1
            }

            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas
        }


        
        jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
    }



    return jsonRegistros.jsonRegistros
}



export const importaApolicePrudentialSiteCliente = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao,
    seguradora, nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    if (PDFTxt.indexOf(fimLinha + 'PAGA' + fimLinha/*'SPWL  VIDA INTEIRA PAGAMENTO'*/) !== -1) {

        jsonRegistros.jsonRegistros[indexJsonRegistros].statusApolice = HARDCODE.idStatusApoliceAtiva

    } else {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'APÓLICE', fimLinha,
            HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice, erros, nomeArquivo)
    }

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Proposta:' + espaco, fimLinha, 
    //    HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)

    jsonRegistros.indexInicial = 0

    obtemDadoPDF(PDFTxt, jsonRegistros, 'Proposta: Número da Apólice:', fimLinha,
            HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)
    
    let linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta = linhaDados[0]

    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice = semZerosEsquerda(linhaDados[1])

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoDataEmissao,
    //    true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha + 'Segurado' + fimLinha,
        HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)

    linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(fimLinha)
    let indLinhaDados = linhaDados.length - 1

    while (linhaDados[indLinhaDados].indexOf('/') === -1) {

        indLinhaDados--
    }

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[indLinhaDados],
        HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)



    if (PDFTxt.indexOf(fimLinha + 'Sexo:' + fimLinha + 'CEP:' + fimLinha) === -1) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo:' + fimLinha, fimLinha,
            HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

        if (isFinite(jsonRegistros.jsonRegistros[indexJsonRegistros].nomeSeguradoCliente.substring(2, 6))) {
            
            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)
        }
        
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha,
            HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

        jsonRegistros.indexInicial += 2

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, espaco + 'Telefone Celular:', 
            HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)

        if (PDFTxt.indexOf('Telefone Comercial:', jsonRegistros.indexInicial) !== -1) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone Comercial:' + fimLinha, fimLinha,
                HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)
            
            //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoTelefoneSegurado, true, null, erros, nomeArquivo)

            //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoTelefoneComercialSegurado, true, null, erros, nomeArquivo)

        } else {

            obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Telefone Celular:' /*+ espaco*/, fimLinha,
                HARDCODE.importacaoCelularSeguradoCliente, false/*true*/, null, erros, nomeArquivo)

            //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone Residencial:' + espaco, 'Email Principal:',
            //    HARDCODE.importacaoTelefoneSegurado, false, null, erros, nomeArquivo)
        }

        obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + */'Email Principal:' /*+ espaco*/, fimLinha + 'Idade na data de emissão:',
            HARDCODE.importacaoEmailSeguradoCliente, false, null, erros, nomeArquivo)

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].emailSeguradoCliente) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Email Alternativo:' + fimLinha, fimLinha,
                HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)
        }

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data de Nascimento:' + espaco, fimLinha,
            HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Endereço de correspondência e pagamento:' + fimLinha, fimLinha,
            HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Cidade:' + espaco, fimLinha,
            HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, 'Bairro:' + fimLinha,
            HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Estado:' + espaco, fimLinha,
            HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

    } else {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Endereço de Correspondência:' + fimLinha,
            fimLinha + 'Telefone Celular:' + fimLinha,
                HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)
    
        linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(fimLinha)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[3],
            HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[4],
            HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[6],
            HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[7],
            HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[1],
            HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[8],
            HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[10],
            HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[9],
            HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhaDados[11],
            HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone Comercial:' + fimLinha, fimLinha,
            HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)
            
        //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoTelefoneSegurado, true, null, erros, nomeArquivo)

        //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoTelefoneComercialSegurado, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + */'Email Principal:' /*+ espaco*/, fimLinha + 'Idade na data de emissão:',
            HARDCODE.importacaoEmailSeguradoCliente, false, null, erros, nomeArquivo)

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].emailSeguradoCliente) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Email Alternativo:' + fimLinha, fimLinha,
                HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)
        }

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data de Nascimento:' + espaco, fimLinha,
            HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)
    }

    /* 
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Responsável pelo Pagamento:' + espaco, espaco + 'CPF / CNPJ:',
        HARDCODE.importacaoNomeRespPagto, false, null, erros, nomeArquivo)

    if (jsonRegistros.jsonRegistros[indexJsonRegistros].nomeRespPagto) {

        obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'CPF / CNPJ:' + espaco, fimLinha,
            HARDCODE.importacaoCpfCnpjRespPagto, true, null, erros, nomeArquivo)
        
        if (jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto.length === 14) {

            jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto = ''

        } else {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo do Responsável pelo Pagamento:' + espaco,
                espaco + 'Profissão Responsável pelo Pagamento:', HARDCODE.importacaoSexoRespPagto, false, null, erros, nomeArquivo)
        }

    } else {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Responsável pelo Pagamento:' + espaco, fimLinha,
            HARDCODE.importacaoNomeRespPagto, true, null, erros, nomeArquivo)
        
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CPF / CNPJ:' + espaco, fimLinha,
            HARDCODE.importacaoCpfCnpjRespPagto, true, null, erros, nomeArquivo)
            
        if (jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto.length === 14) {

            jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto = ''

        } else {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo do Responsável pelo Pagamento:' + espaco,
            fimLinha, HARDCODE.importacaoSexoRespPagto, false, null, erros, nomeArquivo)
        }
    }
    */
    

    
    const coberturas = []

    let numeroCobertura
    let codigoCobertura
    let descricaoCobertura
    let valorCS
    let valorPremioLiquido
    let valorIof
    let valorPremio
    let classeAjusteRisco
    let valorPremioExtra
    let duracaoPremioExtra
    let dataTerminoCobertura
    let valorRendaMensal

    while (PDFTxt.indexOf('Status:', jsonRegistros.indexInicial) !== -1) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Status:' + fimLinha, fimLinha,
            HARDCODE.importacaoDescricaoCobertura, true, null, erros, nomeArquivo)

        if (jsonRegistros.jsonRegistros[indexJsonRegistros].descricaoCobertura === 'EXTENSÃO DE VIGÊNCIA:') {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoDescricaoCobertura, true, null, erros, nomeArquivo)
        }

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoValorCS, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoValorIof, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoValorPremioLiquido, true, null, erros, nomeArquivo)
        
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoValorPremio, true, null, erros, nomeArquivo)

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoDataTerminoCoberturaString, true, null, erros, nomeArquivo)
        
        jsonRegistros.indexInicial += 2

        if (
                jsonRegistros.jsonRegistros[indexJsonRegistros].descricaoCobertura.indexOf('QUEBRA DE OSSOS') === -1 &&
                jsonRegistros.jsonRegistros[indexJsonRegistros].descricaoCobertura.indexOf('CIRURGIA') === -1
        ) {
        
            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoClasseAjusteRisco, true, null, erros, nomeArquivo)
        
        } else {

            jsonRegistros.jsonRegistros[indexJsonRegistros].classeAjusteRisco = ''
        }

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha, HARDCODE.importacaoStatusCobertura, true, null, erros, nomeArquivo)

        const tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(jsonRegistros.jsonRegistros[indexJsonRegistros].descricaoCobertura,
            linhaIntegracao, jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

        descricaoCobertura = jsonRegistros.jsonRegistros[indexJsonRegistros].descricaoCobertura
        valorCS = jsonRegistros.jsonRegistros[indexJsonRegistros].valorCS
        valorPremioLiquido = jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioLiquido
        valorIof = jsonRegistros.jsonRegistros[indexJsonRegistros].valorIof
        valorPremio = jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioLiquido + jsonRegistros.jsonRegistros[indexJsonRegistros].valorIof
        classeAjusteRisco = jsonRegistros.jsonRegistros[indexJsonRegistros].classeAjusteRisco
        valorPremioExtra = ''
        duracaoPremioExtra = ''

        const statusCobertura = identificaStatusCobertura(jsonRegistros.jsonRegistros[indexJsonRegistros].statusCobertura, linhaIntegracao,
            jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

        if (jsonRegistros.jsonRegistros[indexJsonRegistros].dataTerminoCoberturaString === 'VITALÍCIO') {

            dataTerminoCobertura =
                dataAnoMesDia(
                    ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                    mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao),
                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao)
                )

        } else {
            
            dataTerminoCobertura = stringParaData(jsonRegistros.jsonRegistros[indexJsonRegistros].dataTerminoCoberturaString, 'dd/mm/yyyy')
        }

        valorRendaMensal = ''

        incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
            statusCobertura, valorCS, valorPremioLiquido, valorIof, valorPremio, classeAjusteRisco, valorPremioExtra,
                duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)
    }

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Forma de Pagamento:' + fimLinha, fimLinha,
        HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)


        
    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}



export const importaListaApolicesPrudentialImplantacaoConsultorFinanceiroLP = (XLSX, idUsuarioLogado, vars,
    equipeList, linhaIntegracao, seguradora, nomeArquivo, erros, variaveisGlobais) => {

    const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0] && XLSX[linha][28] === 'Apólice') {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            

            const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][13/*2*/])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

           

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 0, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
    
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 23/*5*/, HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice,
                erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 16/*3*/, HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 53/*7*/, HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 58/*10*/, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 56/*9*/, HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 55/*8*/, HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 61/*13*/, HARDCODE.importacaoCidadeSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 62/*14*/, HARDCODE.importacaoUfSeguradoCliente, false, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 59/*11*/, HARDCODE.importacaoEnderecoSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 60/*12*/, HARDCODE.importacaoBairroSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 63/*15*/, HARDCODE.importacaoCepSeguradoCliente, false, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoComplementoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 64/*16*/, HARDCODE.importacaoTelefoneSegurado, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 66/*18*/, HARDCODE.importacaoTelefoneComercialSegurado, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 65/*17*/, HARDCODE.importacaoCelularSeguradoCliente, false, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 67/*19*/, HARDCODE.importacaoEmailSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 69/*20*/, HARDCODE.importacaoNomeRespPagto, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 71/*21*/, HARDCODE.importacaoCpfCnpjRespPagto, true, null, erros, nomeArquivo)
            
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto.length === 14) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto = ''
            }

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoRendaMensal, true, null, erros, nomeArquivo)
           
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 82/*31*/, HARDCODE.importacaoTipoPeriodicidadePagtoPremio,
                true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 83/*32*/, HARDCODE.importacaoTipoFormaPagtoPremio,
                true, null, erros, nomeArquivo)


            
            if (usuarioClienteSelecionado) {
               
                jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
            
                const coberturas = []

                let valorPremioAnualizado = 0

                while (
                            linha < XLSX.length &&
                            ('' + XLSX[linha][0]) === jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice
                ) {

                    valorPremioAnualizado = round(valorPremioAnualizado + trataValorTexto(XLSX[linha][163/*56*/]), 2)

                    let numeroCobertura
                    let codigoCobertura
                    let descricaoCobertura
                    let tipoCoberturaSeguroVida
                    let valorCS
                    let valorPremioLiquido
                    let valorIof
                    let valorPremio
                    let classeAjusteRisco
                    let valorPremioExtra
                    let duracaoPremioExtra
                    let dataTerminoCobertura
                    let valorRendaMensal

                    descricaoCobertura = trataTexto(XLSX[linha][114/*34*/])

                    tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                        jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)
        
                    if (tipoCoberturaSeguroVida) {

                        numeroCobertura = XLSX[linha][113/*33*/]
                        codigoCobertura = XLSX[linha][115/*35*/]
                        valorCS = trataValorTexto(XLSX[linha][145/*46*/])
                        valorPremioLiquido = trataValorTexto(XLSX[linha][159/*53*/])
                        valorIof = trataValorTexto(XLSX[linha][160/*54*/])
                        valorPremio = trataValorTexto(XLSX[linha][161/*55*/])
                        classeAjusteRisco = trataTexto(XLSX[linha][122/*36*/])
                        valorPremioExtra = trataValorTexto(XLSX[linha][146/*47*/])
                        duracaoPremioExtra = trataInteiro(XLSX[linha][149/*50*/])
                        dataTerminoCobertura = trataData(XLSX[linha][141/*45*/])

                        const statusCobertura = identificaStatusCobertura(trataTexto(XLSX[linha][124/*37*/]), linhaIntegracao,
                            jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

                        incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
                            statusCobertura, valorCS, valorPremioLiquido, valorIof, valorPremio,
                                classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)
                        
                        coberturas[coberturas.length - 1].ordem = numeroCobertura
                    }

                    linha++
                }

                jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = valorPremioAnualizado

                jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = sortAsc(coberturas)

            } else {

                erros.push(MESSAGE().agenteNaoEncontradoApolice
                    .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
                        .replace("$codigoAgente$", XLSX[linha][13/*2*/])
                )

                linha++
            }
            
            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)

        } else {

            linha++
        }
    }

    return jsonRegistros.jsonRegistros
}



export const importaListaApolicesPrudentialImplantacaoSemAgente = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    //const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][2/*0*/]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            

            //const usuarioClienteSelecionado = idUsuarioLogado//idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][2])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

           

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 0, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
    
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4/*5*/, HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice,
                erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 2/*3*/, HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 5/*7*/, HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 8/*10*/, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 7/*9*/, HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 6/*8*/, HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 11/*13*/, HARDCODE.importacaoCidadeSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 12/*14*/, HARDCODE.importacaoUfSeguradoCliente, false, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 9/*11*/, HARDCODE.importacaoEnderecoSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 10/*12*/, HARDCODE.importacaoBairroSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 13/*15*/, HARDCODE.importacaoCepSeguradoCliente, false, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoComplementoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 14/*16*/, HARDCODE.importacaoTelefoneSegurado, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 16/*18*/, HARDCODE.importacaoTelefoneComercialSegurado, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 15/*17*/, HARDCODE.importacaoCelularSeguradoCliente, false, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 17/*19*/, HARDCODE.importacaoEmailSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 18/*20*/, HARDCODE.importacaoNomeRespPagto, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 19/*21*/, HARDCODE.importacaoCpfCnpjRespPagto, true, null, erros, nomeArquivo)
            
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto.length === 14) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].cpfRespPagto = ''
            }

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoRendaMensal, true, null, erros, nomeArquivo)
           
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 29/*31*/, HARDCODE.importacaoTipoPeriodicidadePagtoPremio,
                true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 30/*32*/, HARDCODE.importacaoTipoFormaPagtoPremio,
                true, null, erros, nomeArquivo)


            
            //if (usuarioClienteSelecionado) {
               
                //jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
            
                const coberturas = []

                let valorPremioAnualizado = 0

                while (
                            linha < XLSX.length &&
                            ('' + XLSX[linha][0]) === jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice
                ) {

                    valorPremioAnualizado = round(valorPremioAnualizado + trataValorTexto(XLSX[linha][54/*56*/]), 2)

                    let numeroCobertura
                    let codigoCobertura
                    let descricaoCobertura
                    let tipoCoberturaSeguroVida
                    let valorCS
                    let valorPremioLiquido
                    let valorIof
                    let valorPremio
                    let classeAjusteRisco
                    let valorPremioExtra
                    let duracaoPremioExtra
                    let dataTerminoCobertura
                    let valorRendaMensal

                    descricaoCobertura = trataTexto(XLSX[linha][32/*34*/])

                    tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                        jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)
        
                    if (tipoCoberturaSeguroVida) {

                        numeroCobertura = XLSX[linha][31/*33*/]
                        codigoCobertura = XLSX[linha][33/*35*/]
                        valorCS = trataValorTexto(XLSX[linha][44/*46*/])
                        valorPremioLiquido = trataValorTexto(XLSX[linha][51/*53*/])
                        valorIof = trataValorTexto(XLSX[linha][52/*54*/])
                        valorPremio = trataValorTexto(XLSX[linha][53/*55*/])
                        classeAjusteRisco = trataTexto(XLSX[linha][34/*36*/])
                        valorPremioExtra = trataValorTexto(XLSX[linha][45/*47*/])
                        duracaoPremioExtra = trataInteiro(XLSX[linha][48/*50*/])
                        dataTerminoCobertura = trataData(XLSX[linha][43/*45*/])

                        const statusCobertura = identificaStatusCobertura(trataTexto(XLSX[linha][35/*37*/]), linhaIntegracao,
                            jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

                        incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
                            statusCobertura, valorCS, valorPremioLiquido, valorIof, valorPremio,
                                classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)
                        
                        coberturas[coberturas.length - 1].ordem = numeroCobertura
                    }

                    linha++
                }

                jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = valorPremioAnualizado

                jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = sortAsc(coberturas)

            //} else {

            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][2])
            //    )

            //    linha++
            //}
            
            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)

        } else {

            linha++
        }
    }

    return jsonRegistros.jsonRegistros
}



export const importaListaCobrancasPrudential = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    //const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (
                XLSX[linha][1] &&
                (
                    (
                        XLSX[linha][18]/*numeroParcela*/ > 1 && !(XLSX[linha][19] === 'Aguardando Faturamento' && !XLSX[linha][20])
                    ) ||
                    XLSX[linha][26]/*dataPagamento*/
                )
        ) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            //const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][?])

            //if (usuarioClienteSelecionado) {

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
                
                obtemDadoXLSX(XLSX, jsonRegistros, linha, 32, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoBanco, false, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoAgencia, false, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoConta, false, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, 37/*38*/, HARDCODE.importacaoLinhaDados, false, null, erros, nomeArquivo)

                //if (jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados) {

                //    const conta = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

                //    jsonRegistros.jsonRegistros[indexJsonRegistros].banco = zerosEsquerda(conta[conta.length - 6], 3)
                //    jsonRegistros.jsonRegistros[indexJsonRegistros].agencia = conta[conta.length - 3]
                //    jsonRegistros.jsonRegistros[indexJsonRegistros].conta = conta[conta.length - 1]
                //}

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 18, HARDCODE.importacaoNumeroParcela, true, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 19, HARDCODE.importacaoStatusParcela, true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoTipoBaixaParcela, true, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 22, HARDCODE.importacaoDataVencimento, true, null, erros, nomeArquivo)
                
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoDiaVencimento, true, null, erros, nomeArquivo)
                jsonRegistros.jsonRegistros[indexJsonRegistros].diaVencimento =
                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataVencimento)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 0, HARDCODE.importacaoDataCompetencia, true, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoDataInicioVigencia, true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, 20, HARDCODE.importacaoDataFimVigencia, true, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 26, HARDCODE.importacaoDataPagamento, false, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 27, HARDCODE.importacaoDataApropriacao, false, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 28, HARDCODE.importacaoValorAPagar, true, null, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 30, HARDCODE.importacaoValorPago, true, null, erros, nomeArquivo)

                //obtemDadoXLSX(XLSX, jsonRegistros, linha, 17, HARDCODE.importacaoTipoPeriodicidadePagtoPremio,
                //    true, null, erros, nomeArquivo)
                obtemDadoXLSX(XLSX, jsonRegistros, linha, 17, HARDCODE.importacaoTipoPeriodicidadePagtoPremioInteiro, true,
                    linhaIntegracao.tipoPeriodicidadePagtoPremio, erros, nomeArquivo)

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 11, HARDCODE.importacaoNumeroCobertura,
                    true, null, erros, nomeArquivo)
                
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoCodigoCobertura,
                //    true, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoDescricaoCobertura,
                //    true, null, erros, nomeArquivo)
                //obtemDadoXLSX(XLSX, jsonRegistros, linha, 15, HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)

                //if (jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados) {

                //    const descricaoCobertura = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(' - ')

                //    jsonRegistros.jsonRegistros[indexJsonRegistros].codigoCobertura =
                //        descricaoCobertura[descricaoCobertura.length - 1]

                //    jsonRegistros.jsonRegistros[indexJsonRegistros].descricaoCobertura =
                //        obtemTextoArray(descricaoCobertura, 0, descricaoCobertura.length - 2)
                //}

            //} else {
        
            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", XLSX[linha][?])
            //            .replace("$codigoAgente$", XLSX[linha][?])
            //    )
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }

    return jsonRegistros.jsonRegistros
}



export const importaListaComissoesPrudential = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            //const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][30])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 13, HARDCODE.importacaoNumeroParcela, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoNumeroParcelaFaturada, false, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 14, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 35, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoDataGeracaoComissao, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 6, HARDCODE.importacaoValorBaseCalculoComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 20, HARDCODE.importacaoPercAngariacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 19, HARDCODE.importacaoValorAngariacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 7, HARDCODE.importacaoPercComissao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao * 100

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoValorComissao, true, null, erros, nomeArquivo)
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao === 0) {
            
                obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoValorComissao, true, null, erros, nomeArquivo)
            }

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 24, HARDCODE.importacaoPercEstorno, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 23, HARDCODE.importacaoValorEstorno, true, null, erros, nomeArquivo)
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao < 0) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao * -1

                jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorEstorno =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao * -1

                jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao = 0
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao = 0
            }

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 26, HARDCODE.importacaoPercIncentivo, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 25, HARDCODE.importacaoValorIncentivo, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 28, HARDCODE.importacaoPercBonificacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 27, HARDCODE.importacaoValorBonificacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 19, HARDCODE.importacaoCodigoCobertura, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 10, HARDCODE.importacaoDescricaoCobertura, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoTotal, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 5, HARDCODE.importacaoNumeroCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoAgentesComissao, true, null, erros, nomeArquivo)

            //if (usuarioClienteSelecionado) {
               
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
                 
            //} else {
        
            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][30])
            //    )
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }
    

    return jsonRegistros.jsonRegistros
}



export const importaListaComissoesPrudentialSegundoLayout = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            //const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][30])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 26/*27*/, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
                '' + parseInt(jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 20/*21*/, HARDCODE.importacaoNumeroParcela, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroParcelaFaturada, false, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 21/*22*/, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 7, HARDCODE.importacaoDataGeracaoComissao, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 11, HARDCODE.importacaoValorBaseCalculoComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercAngariacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorAngariacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 12/*13*/, HARDCODE.importacaoPercComissao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao * 100

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 15/*16*/, HARDCODE.importacaoValorComissao, true, null, erros, nomeArquivo)
            //if (jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao === 0) {
            
            //    obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissao, true, null, erros, nomeArquivo)
            //}

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercEstorno, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorEstorno, true, null, erros, nomeArquivo)
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao < 0) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao * -1

                jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorEstorno =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao * -1

                jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao = 0
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao = 0
            }

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercIncentivo, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorIncentivo, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercBonificacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorBonificacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 16/*17*/, HARDCODE.importacaoCodigoCobertura, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 17/*18*/, HARDCODE.importacaoDescricaoCobertura, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoTotal, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 10, HARDCODE.importacaoNumeroCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoAgentesComissao, true, null, erros, nomeArquivo)

            //if (usuarioClienteSelecionado) {
               
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
                 
            //} else {
        
            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][30])
            //    )
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }
    

    return jsonRegistros.jsonRegistros
}



export const importaListaRecapturePrudential = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            //const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][30])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 18, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 7, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 6, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
                semZerosEsquerda(jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 13, HARDCODE.importacaoNumeroParcela, true, null, erros, nomeArquivo)
            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroParcela = HARDCODE.numeroParcelaRecapture
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoNumeroParcelaFaturada, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 14, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 35, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 11, HARDCODE.importacaoDataGeracaoComissao, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 14, HARDCODE.importacaoValorBaseCalculoComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 20, HARDCODE.importacaoPercAngariacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 19, HARDCODE.importacaoValorAngariacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 13, HARDCODE.importacaoPercComissao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao * 100

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 15, HARDCODE.importacaoValorComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 24, HARDCODE.importacaoPercEstorno, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 23, HARDCODE.importacaoValorEstorno, true, null, erros, nomeArquivo)
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao < 0) {

                //jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao =
                //    jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao * -1

                jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorEstorno =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao * -1

                jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao = 0
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao = 0
            }

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 26, HARDCODE.importacaoPercIncentivo, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 25, HARDCODE.importacaoValorIncentivo, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 28, HARDCODE.importacaoPercBonificacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 27, HARDCODE.importacaoValorBonificacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 16, HARDCODE.importacaoCodigoCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 10, HARDCODE.importacaoDescricaoCobertura, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoTotal, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 5, HARDCODE.importacaoNumeroCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoAgentesComissao, true, null, erros, nomeArquivo)

            //if (usuarioClienteSelecionado) {
               
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
                 
            //} else {
        
            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][30])
            //    )
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }
    

    return jsonRegistros.jsonRegistros
}



export const importaCotacaoPrudentialTabelaEvolucaoValorResgate = (values, item, linhaIntegracaoCotacao,
    PDFTxt, nomeArquivo, erros) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)
    


    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data da simulação:' + espaco, fimLinha,
        HARDCODE.importacaoDataCotacaoExtenso, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].dataCotacaoExtenso) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data da impressão:' + espaco, espaco + 'Data da última alteração:' + espaco,
            HARDCODE.importacaoDataCotacaoExtenso, true, null, erros, nomeArquivo)
    }
    


    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Idade do Segurado Capital segurado (R$) Valor Quitado (R$) Valor de Resgate (R$) Valor Saldado (R$) Benefício Prolongado' + fimLinha,
        espaco + 'Valor de resgate se Iguala ao capital segurado' + fimLinha,
            HARDCODE.importacaoTabelaEvolucaoValorResgate, false, null, erros, nomeArquivo)

    let singlePremium = false
    let comResgate = true

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

        // Sem Resgate
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Idade do Segurado Capital segurado (R$) Valor Quitado (R$) Valor Saldado (R$) Benefício Prolongado' + fimLinha,
            fimLinha + 'Valor Saldado: O "valor saldado" é a interrupção definitiva do pagamento do prêmio,',
                HARDCODE.importacaoTabelaEvolucaoValorResgate, false, null, erros, nomeArquivo)

         if (!jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {
    
            // Single Premium
            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Idade do Segurado Capital segurado (R$) Valor Quitado (R$) Valor de Resgate (R$)' + fimLinha,
                espaco + 'Valor de resgate se Iguala ao capital segurado' + fimLinha,
                    HARDCODE.importacaoTabelaEvolucaoValorResgate, true, null, erros, nomeArquivo)

            singlePremium = true

        } else {

            comResgate = false
        }
    }



    if (jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

        const linhasTabelaEvolucaoValorResgateAux =
            jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate.split(fimLinha)
        let indexLinhasTabelaEvolucaoValorResgateAux = 0

        const linhasTabelaEvolucaoValorResgate = []
        let indexLinhasTabelaEvolucaoValorResgate = 0

        let numeroCotacao = numeroCotacaoAutomatico()
        let dataCotacao = converteDataExtensoData(jsonRegistros.jsonRegistros[indexJsonRegistros].dataCotacaoExtenso)
        let ano
        let idade
        let valorCS
        let valorPremioAnualizadoAcumulado
        let valorResgate
        let valorSaldado
        let beneficioProlongado

        item.tabelaEvolucaoValorResgate = []

        let dadosTabelaEvolucaoValorResgate

        while (indexLinhasTabelaEvolucaoValorResgateAux < linhasTabelaEvolucaoValorResgateAux.length) {

            if (
                    linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux].substring(0, 4) === 'ANO ' &&
                    linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux].indexOf('|') === -1
            ) {

                linhasTabelaEvolucaoValorResgate.push(
                    linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux]
                )
            }

            indexLinhasTabelaEvolucaoValorResgateAux++
        }

        while (indexLinhasTabelaEvolucaoValorResgate < linhasTabelaEvolucaoValorResgate.length) {

            dadosTabelaEvolucaoValorResgate =
                linhasTabelaEvolucaoValorResgate[indexLinhasTabelaEvolucaoValorResgate].split(espaco)

            ano = Number.parseInt(dadosTabelaEvolucaoValorResgate[1])
            idade = Number.parseInt(dadosTabelaEvolucaoValorResgate[2].substring(1))
            valorCS = trataValorTexto(dadosTabelaEvolucaoValorResgate[4])
            valorPremioAnualizadoAcumulado = trataValorTexto(dadosTabelaEvolucaoValorResgate[5])
            valorResgate = comResgate ? trataValorTexto(dadosTabelaEvolucaoValorResgate[6]) : ''
            valorSaldado = singlePremium ? '' : trataValorTexto(dadosTabelaEvolucaoValorResgate[comResgate ? 7 : 6])
            beneficioProlongado = ''
            
            let indexDadosTabelaEvolucaoValorResgate = comResgate ? 8 : 7

            while (indexDadosTabelaEvolucaoValorResgate < dadosTabelaEvolucaoValorResgate.length) {

                beneficioProlongado +=
                    dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate] + espaco

                indexDadosTabelaEvolucaoValorResgate++
            }

            beneficioProlongado = beneficioProlongado.trim()
            
            incluiTabelaEvolucaoValorResgateCoberturaVidaInteira(values, item, numeroCotacao, dataCotacao, ano, idade, valorCS,
                valorPremioAnualizadoAcumulado, valorResgate, valorSaldado, beneficioProlongado, null, null)

            indexLinhasTabelaEvolucaoValorResgate++
        }
    }


    
    //jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    //return jsonRegistros.jsonRegistros
}

export const importaCotacaoPrudentialTabelaEvolucaoValorResgateLifePlanner = (values, item, linhaIntegracaoCotacao,
    PDFTxt, nomeArquivo, erros) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)
    


    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Elaboração:' + espaco, espaco,
        HARDCODE.importacaoDataCotacao, true, null, erros, nomeArquivo)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'PROLONGADO' + fimLinha,
            espaco + '0,00 Vida Inteira' + fimLinha,
                HARDCODE.importacaoTabelaEvolucaoValorResgate, true, null, erros, nomeArquivo)

    //let singlePremium = false

    //if (!jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {
    
    //    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Idade do Segurado Capital segurado (R$) Valor Quitado (R$) Valor de Resgate (R$)' + fimLinha,
    //        espaco + 'Valor de resgate se Iguala ao capital segurado' + fimLinha,
    //            HARDCODE.importacaoTabelaEvolucaoValorResgate, true, null, erros, nomeArquivo)

    //    singlePremium = true
    //}



    if (jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

        const linhasTabelaEvolucaoValorResgateAux =
            jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate.split(fimLinha)
        let indexLinhasTabelaEvolucaoValorResgateAux = 0

        const linhasTabelaEvolucaoValorResgate = []
        let indexLinhasTabelaEvolucaoValorResgate = 0

        let numeroCotacao = numeroCotacaoAutomatico()
        let dataCotacao = jsonRegistros.jsonRegistros[indexJsonRegistros].dataCotacao
        let ano
        let idade
        let valorCS
        let valorPremioAnualizadoAcumulado
        let valorResgate
        let valorSaldado
        let beneficioProlongado

        item.tabelaEvolucaoValorResgate = []

        let dadosTabelaEvolucaoValorResgate

        while (indexLinhasTabelaEvolucaoValorResgateAux < linhasTabelaEvolucaoValorResgateAux.length) {

            if (linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux].indexOf(' ANOS) ') !== -1) {

                linhasTabelaEvolucaoValorResgate.push(
                    linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux]
                )
            }

            indexLinhasTabelaEvolucaoValorResgateAux++
        }

        while (indexLinhasTabelaEvolucaoValorResgate < linhasTabelaEvolucaoValorResgate.length) {

            dadosTabelaEvolucaoValorResgate =
                linhasTabelaEvolucaoValorResgate[indexLinhasTabelaEvolucaoValorResgate].split(espaco)

            ano = Number.parseInt(dadosTabelaEvolucaoValorResgate[0])
            idade = Number.parseInt(dadosTabelaEvolucaoValorResgate[1].substring(dadosTabelaEvolucaoValorResgate[1].indexOf('(') + 1))
            valorCS = trataValorTexto(linhasTabelaEvolucaoValorResgate[linhasTabelaEvolucaoValorResgate.length - 1].split(espaco)[4])
            valorPremioAnualizadoAcumulado = trataValorTexto(dadosTabelaEvolucaoValorResgate[3])
            valorResgate = trataValorTexto(dadosTabelaEvolucaoValorResgate[4])
            valorSaldado = /*singlePremium ? '' : */trataValorTexto(dadosTabelaEvolucaoValorResgate[5])
            beneficioProlongado = ''
            
            let indexDadosTabelaEvolucaoValorResgate = 6

            while (indexDadosTabelaEvolucaoValorResgate < dadosTabelaEvolucaoValorResgate.length) {

                beneficioProlongado +=
                    dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate] + espaco

                indexDadosTabelaEvolucaoValorResgate++
            }

            beneficioProlongado = beneficioProlongado.trim()
            
            incluiTabelaEvolucaoValorResgateCoberturaVidaInteira(values, item, numeroCotacao, dataCotacao, ano, idade, valorCS,
                valorPremioAnualizadoAcumulado, valorResgate, valorSaldado, beneficioProlongado, null, null)

            indexLinhasTabelaEvolucaoValorResgate++
        }
    }


    
    //jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    //return jsonRegistros.jsonRegistros
}



const importaCotacaoPrudentialXPTabelaEvolucaoValorResgate = (values, item, linhaIntegracaoCotacao, XLSX, deslocamento) => {

    let linha = linhaIntegracaoCotacao.cabecalho + 1

    let numeroCotacao = numeroCotacaoAutomatico()
    let dataCotacao = dataAtual()
    let ano = 0
    let idade
    let valorCS
    let valorPremioAnualizadoAcumulado
    let valorResgate
    let valorSaldado
    let beneficioProlongado

    item.tabelaEvolucaoValorResgate = []

    while (linha < XLSX.length) {

        if (XLSX[linha][1]) {

            ano++
            idade = XLSX[linha][1]
            valorCS = XLSX[linha][2]
            valorPremioAnualizadoAcumulado =
                XLSX[linha][4 + deslocamento] === 'Apólice Quitada' || !XLSX[linha][5 + deslocamento]
                    ?
                        0
                    :
                        XLSX[linha][5 + deslocamento]
            valorResgate = XLSX[linha][6 + deslocamento]
            valorSaldado = ''
            beneficioProlongado = ''

            incluiTabelaEvolucaoValorResgateCoberturaVidaInteira(values, item, numeroCotacao, dataCotacao, ano, idade, valorCS,
                valorPremioAnualizadoAcumulado, valorResgate, valorSaldado, beneficioProlongado, null, null)
        }

        linha++
    }
}

export const importaCotacaoPrudentialXPTabelaEvolucaoValorResgateAtual = (values, item, linhaIntegracaoCotacao, XLSX) => {

    importaCotacaoPrudentialXPTabelaEvolucaoValorResgate(values, item, linhaIntegracaoCotacao, XLSX, 0)
}

export const importaCotacaoPrudentialXPTabelaEvolucaoValorResgateAntiga = (values, item, linhaIntegracaoCotacao, XLSX) => {

    importaCotacaoPrudentialXPTabelaEvolucaoValorResgate(values, item, linhaIntegracaoCotacao, XLSX, -1)
}